import CustomBackButton from "@/components/custom/custom-back-button";
import { profileSchema } from "@/schemas/user.schema";
import {
  Avatar,
  Box,
  CircularProgress,
  Divider,
  styled,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";
import { useAdminUserById } from "@/hooks/use-admin-user-by-id";
import { formatName } from "@/utils/format-name";
import { AdminProfileDetails } from "./_components/admin-profile-details";

const SectionRoot = styled("section")(({ theme }) => ({
  margin: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Card = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "16px 20px",
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const SectionWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 3),
}));

const AdminUser = () => {
  const { userId } = useParams();
  const { data, isLoading } = useAdminUserById(userId);

  const profileFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: data?.firstName ?? "",
      lastName: data?.surname ?? "",
      email: data?.email ?? "",
      phoneNumber: data?.phoneNumber ?? "",
      address: data?.address ?? "",
      district: data?.district ?? "",
      city: data?.city ?? "",
      state: data?.state ?? "",
      gender: data?.gender ?? "",
      isActive: data?.active ?? undefined,
    },
    validationSchema: profileSchema,
    onSubmit: (values) => {
      console.log("PROFILE:", values);
    },
  });

  if (isLoading) {
    return (
      <SectionRoot>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <CircularProgress size={16} thickness={4} />
          <Typography variant="body2" color="text.secondary">
            Loading...
          </Typography>
        </Box>
      </SectionRoot>
    );
  }

  if (!data) return null;

  const fullName =
    data?.firstName && data?.surname
      ? formatName(data.firstName, data.surname)
      : "Waya Admin User";

  return (
    <SectionRoot>
      <Card>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <CustomBackButton />
            <Avatar
              alt="user-profile-pic"
              src={""}
              sx={{ width: 72, height: 72 }}
            />
            <Box>
              <Typography variant="h5">{fullName}</Typography>
              <Typography variant="body2" color="text.secondary">
                Admin User
              </Typography>
            </Box>
          </Box>
        </Box>
        <SectionWrapper>
          <Typography variant="h6" fontWeight={500}>
            Admin Profile
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Update your admin information here.
          </Typography>
        </SectionWrapper>
        <Divider />
        <SectionWrapper>
          <form onSubmit={profileFormik.handleSubmit}>
            <AdminProfileDetails formik={profileFormik} isDisabled={false} />
          </form>
        </SectionWrapper>
      </Card>
    </SectionRoot>
  );
};

export default AdminUser;
